/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { JoysticksKind_Enum, joysticksKind_EnumFromJSON, joysticksKind_EnumToJSON } from "./joysticks_kind";
import { UiAxis } from "./ui_axis";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface JoysticksInputs {
  utime: number;
  deviceId: string;
  kind: JoysticksKind_Enum;
  axes: UiAxis[];
}

function createBaseJoysticksInputs(): JoysticksInputs {
  return { utime: 0, deviceId: "", kind: 0, axes: [] };
}

export const JoysticksInputs = {
  encode(message: JoysticksInputs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).sint64(message.utime);
    }
    if (message.deviceId !== "") {
      writer.uint32(18).string(message.deviceId);
    }
    if (message.kind !== 0) {
      writer.uint32(24).int32(message.kind);
    }
    for (const v of message.axes) {
      UiAxis.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): JoysticksInputs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoysticksInputs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.axes.push(UiAxis.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoysticksInputs {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      kind: isSet(object.kind) ? joysticksKind_EnumFromJSON(object.kind) : 0,
      axes: globalThis.Array.isArray(object?.axes) ? object.axes.map((e: any) => UiAxis.fromJSON(e)) : [],
    };
  },

  toJSON(message: JoysticksInputs): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.kind !== 0) {
      obj.kind = joysticksKind_EnumToJSON(message.kind);
    }
    if (message.axes?.length) {
      obj.axes = message.axes.map((e) => UiAxis.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoysticksInputs>, I>>(base?: I): JoysticksInputs {
    return JoysticksInputs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoysticksInputs>, I>>(object: I): JoysticksInputs {
    const message = createBaseJoysticksInputs();
    message.utime = object.utime ?? 0;
    message.deviceId = object.deviceId ?? "";
    message.kind = object.kind ?? 0;
    message.axes = object.axes?.map((e) => UiAxis.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
